import { useSelector } from 'react-redux';
import CopyButton from '../common/CopyButton';
import JunoButton from '../common/JunoButton';
import { formatDateTime } from '../../../client/Juno/helpers';
import { useEffect, useState } from 'react';
import EditProfile from './EditProfile';
import ActionConfirmModal from '../common/ActionConfirmModal';
import clsx from 'clsx';

function DisabledTextField({ label, value, onChange, copyable = true }) {
    return (
        <div className={'flex gap-3 flex-col'}>
            <span className="block self-stretch text-profile-text-muted text-xs font-medium uppercase leading-none">
                {label}
            </span>
            <div className="self-stretch h-14 pl-4 pr-3 py-3 bg-card-bg rounded-lg outline outline-1 outline-offset-[-1px] outline-[#E4E4E7] dark:outline-[#3F3F46] inline-flex justify-center items-center gap-2.5 overflow-hidden">
                <input
                    type="text"
                    className="flex-1 text-[#A0A0AB] dark:text-[#70707B] bg-card-bg text-base font-medium leading-tight"
                    value={value || '-'}
                    onChange={onChange}
                    disabled={true}
                />
                {copyable ? <CopyButton copyValue={value || '-'} /> : null}
            </div>
        </div>
    );
}

const PersonalInfo = ({ modalFlag, setModalFlag }) => {
    const clientData = useSelector(state => state.juno.clientData);
    const [modals, setModals] = useState({
        openEditModal: false,
        openDeleteConfirmModal: false,
    });

    const { readOnly } = clientData || {};

    const fieldList = [
        {
            key: 'name',
            label: 'Account Holder Name',
            value: clientData?.name,
        },
        {
            key: 'accNumber',
            label: 'Account Number',

            value: clientData?.accountNumber,
        },
        { key: 'email', label: 'Email', value: clientData?.clientEmail },
        {
            key: 'phone',
            label: 'Phone Number',

            value: clientData?.phoneNumber,
        },
        {
            key: 'birthday',
            label: 'Birthday',
            value: formatDateTime(clientData?.dob),
            copyable: false,
        },
        { key: 'address', label: 'Address', value: clientData?.address },
        { key: 'city', label: 'City', value: clientData?.city },
        {
            key: 'postcode',
            label: 'Postcode',

            value: clientData?.postCode,
        },
        { key: 'country', label: 'Country', value: clientData?.country },
    ];

    useEffect(() => {
        if (modalFlag != undefined) {
            setModals({ openEditModal: modalFlag });
        }
    }, [modalFlag]);

    return (
        <>
            <div className="p-3 md:p-6 bg-modal-bg md:bg-transparent">
                <div className="hidden lg:block self-stretch h-14 inline-flex flex-col justify-center items-start gap-4">
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                        <div className="justify-start text-profile-primary text-sm font-semibold leading-tight uppercase">
                            PERSONAL INFORMATION
                        </div>
                        <div
                            className={clsx(
                                'justify-center text-profile-accent text-sm font-semibold uppercase leading-tight cursor-pointer',
                                readOnly && '!cursor-not-allowed',
                            )}
                            onClick={readOnly ? null : () => setModals({ openEditModal: true })}>
                            Edit
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 mb-4">
                    <div className="col-span-1 lg:pr-4">
                        <DisabledTextField
                            label={'creation date'}
                            value={formatDateTime(clientData?.createdAt, true)}
                            copyable={false}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 ">
                    {fieldList.map(field => (
                        <DisabledTextField {...field} key={field.key} />
                    ))}
                </div>
            </div>
            {/* TODO: implement delete functionality */}
            {/*<div className="hidden lg:block self-stretch h-px relative dark:bg-[#3F3F46]" />
         <div className="p-6 inline-flex flex-col justify-center items-start gap-2 hidden lg:block">
                <div className="uppercase justify-start text-profile-primary text-sm font-semibold leading-tight">
                    DELETE ACCOUNT
                </div>
                <div className="text-xs font-medium uppercase leading-none text-[#51525C] dark:text-[#A0A0AB] mt-2">
                    <span>Delete</span>
                    <span className="text-text text-xs font-bold uppercase leading-none">
                        {' '}
                        {clientData?.name}{' '}
                    </span>
                    <span>client account. This action cannot be undone.</span>
                </div>
                 <JunoButton
                    onClick={() =>
                        setModals((prev) => ({
                            ...prev,
                            openDeleteConfirmModal: true,
                        }))
                    }
                    type="otherRedText"
                    className={
                        '!w-40 !px-2 mt-6 !text-sm font-semibold hidden lg:block'
                    }
                >
                    Delete account
                </JunoButton> 
            </div>*/}
            {modals.openEditModal ? (
                <EditProfile
                    open={modals.openEditModal}
                    onClose={() => {
                        setModals({ openEditModal: false });
                        if (setModalFlag) {
                            setModalFlag(false);
                        }
                    }}
                />
            ) : null}
            {modals.openDeleteConfirmModal ? (
                <ActionConfirmModal
                    type={'delete'}
                    open={modals.openDeleteConfirmModal}
                    noDivider={true}
                    heading="delete account!"
                    customSubHead={() => (
                        <div className="self-stretch text-center justify-center text-profile-primary text-sm font-medium  uppercase leading-tight">
                            <span>
                                Are you sure you want to delete the{' '}
                                <span className="text-text text-sm font-semibold  uppercase leading-tight">
                                    Jonathan Hopkins
                                </span>{' '}
                                client account?
                            </span>
                            <span className="mt-4 block">This action cannot be undone.</span>
                        </div>
                    )}
                    onCancel={() =>
                        setModals(prev => ({
                            ...prev,
                            openDeleteConfirmModal: false,
                        }))
                    }
                />
            ) : null}
        </>
    );
};

export default PersonalInfo;
